
import { computed, defineComponent } from 'vue';

import { useRoute } from 'vue-router';

import Layout from '@/components/Layout.vue';

export default defineComponent({
  components: {
    Layout,
  },
  setup() {
    const route = useRoute();

    // A framed page moves our path itself as it navigates, and a remount would reload the frame:
    // it stays mounted for its route, see NextFrame
    const viewKey = computed(() => (route.meta.frame ? route.matched[0]?.path : route.fullPath));

    return {
      viewKey,
    };
  },
});
